module.exports = __webpack_public_path__ + "static/img/1920-x-600.b32be6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1920-x-600.jpg
// module id = 906
// module chunks = 32